
import { Component, Vue } from 'nuxt-property-decorator'
import type { MetaInfo } from 'vue-meta'
import { OnMounted, WithHead } from '~/core/vue.types'
import CoverageMap from '~/components/sections/coverage/CoverageMap.vue'
import CoverageBanner from '~/components/sections/coverage/CoverageBanner.vue'
import AccordionList from '~/components/sections/accordion/AccordionList.vue'
import AccordionItem from '~/components/sections/accordion/AccordionItem.vue'
import SaveRouteMixin from '~/mixins/save-route.mixin'
import { useSEOMetaComposer } from '~/composables/seo.composable'

@Component({
  nuxtI18n: {
    paths: {
      en: '/coverage/',
      de: '/abdeckungskarte/',
      fr: '/couverture/',
    },
  },
  components: {
    CoverageMap,
    CoverageBanner,
    AccordionList,
    AccordionItem,
  },
  mixins: [SaveRouteMixin],

})
export default class CoveragePage extends Vue implements WithHead, OnMounted {
  readonly specificSEOProvidersList = [
    'salt',
    'wingo',
    'yallo',
    'sunrise',
    'swisscom',
  ]

  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.seoTitle,
        description: this.seoDescription,
        route: { name: 'coverage' },
      },
    )
  }

  get seoTitle () {
    return this.specificSEOProvidersList.includes(this.selectedProviderByDefault)
      ? this.$t(`head.meta.coverage.${this.selectedProviderByDefault}.title`).toString()
      : this.$t('head.meta.coverage.title').toString()
  }

  get seoDescription () {
    return this.specificSEOProvidersList.includes(this.selectedProviderByDefault)
      ? this.$t(`head.meta.coverage.${this.selectedProviderByDefault}.description`).toString()
      : this.$t('head.meta.coverage.description').toString()
  }

  get selectedProviderByDefault (): string {
    return (this.$route.query.provider as string) || ''
  }

  mounted () {
    this.$analytics.GTM.sendPageViewEvent({
      routeName: this.$route.name as string,
      pageTitle: this.$metaInfo.title || '',
      fullPath: this.$route.fullPath,
      fromPath: this.$nuxt.context.from ? this.$nuxt.context.from.fullPath : '',
      contentGroup: 'About us',
    })
  }
}
